"use client";

import { useTheme } from "next-themes";
import { useEffect } from "react";

/**
 * Dynamically applies the pastel-grid-light class only when the resolved theme is light.
 * Keeps dark theme background (purana wala) untouched.
 */
export function ThemeBodyClassManager() {
  const { theme, systemTheme } = useTheme();

  useEffect(() => {
    const resolved = theme === "system" ? systemTheme : theme;
    const el = document.body;
    if (resolved === "light") {
      el.classList.add("pastel-grid-light");
      el.classList.remove(
        "dark-grid-animated",
        "dark-veil-base",
        "dark-lux",
        "dark-waves"
      );
    } else if (resolved === "dark") {
      el.classList.remove(
        "pastel-grid-light",
        "dark-grid-animated",
        "dark-veil-base",
        "dark-lux"
      );
      el.classList.add("dark-waves");
      // Inject waves layer element if not present
      if (!document.querySelector(".bg-waves")) {
        const div = document.createElement("div");
        div.className = "bg-waves";
        // Insert as first element to keep behind other content
        document.body.prepend(div);
      }
    }
  }, [theme, systemTheme]);

  return null;
}
